import React, { useId, useState } from 'react';
import { Form, Input, NumberParam, RequiredHelpPhrase, Row, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useDelayed } from '../../../hooks/useDelayed';

export type TopHeadlineBlockEditForm = SonForm<NumberParam<'initialVisibleItemsCount'>>;

export function TopHeadlinesBlockEdit({ form }: { form: TopHeadlineBlockEditForm }) {
  const { t } = useSonTranslation('TopHeadlinesForm');
  const { refresh } = useRefreshBlock();
  const delayedRefresh = useDelayed(refresh);
  const [blockEditForm, setBlockEditForm] = useState(false);
  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedRefresh });
  const id = useId();

  const initialVisibleItemsCount = params.getByName('initialVisibleItemsCount');

  return (
    <>
      <BlockBar
        heading={t('blockEdit.title')}
        hierarchy={3}
        modifier={!blockEditForm ? 'border-bottom' : undefined}
      >
        <BlockBarButton
          text={t('blockEdit.editButtonLabel')}
          svgSpriteId={blockEditForm ? Icons.DECLINE_CROSS : Icons.EDIT_PENCIL}
          onClick={() => {
            setBlockEditForm(!blockEditForm);
          }}
          aria-controls={id}
          aria-expanded={blockEditForm}
        />
      </BlockBar>
      <div className="top-headlines__form-container" id={id}>
        {blockEditForm
          ? <Form {...formProps}>
              <RequiredHelpPhrase />
              <Row>
                <Input
                  label={t('blockEdit.form.initialVisibleItemsCount.label')}
                  helpText={t('blockEdit.form.initialVisibleItemsCount.helpText')}
                  param={initialVisibleItemsCount}
                />
              </Row>
              <SubmitButton
                buttonLabel={t('blockEdit.form.submitButtonLabel')}
                messageSuccess={t('blockEdit.form.status.success')}
                messageSending={t('blockEdit.form.status.sending')}
                messageFail={t('blockEdit.form.status.fail')}
                fetchState={fetchState}
              />
            </Form>
          : null}
      </div>
    </>
  );
}
